import {Decoder, tools, Reader} from 'ts-ebml';
import logger from '@/modules/Logger';

const readAsArrayBuffer = function(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onloadend = () => { resolve(reader.result); };
        reader.onerror = (ev) => { reject(ev.error); };
    });
}

/**
 * Rewrites a recorded WebM blob so its metadata (duration, cues) is seekable.
 * If ts-ebml can't parse an element (e.g. "No schema entry found for unknown"), we fall back to the original blob, which is still a valid, playable WebM so the download isn't blocked.
 */
const injectMetadata = function(blob) {
    const decoder = new Decoder();
    const reader = new Reader();
    reader.logging = false;
    reader.drop_default_duration = false;

    return readAsArrayBuffer(blob).then((buffer) => {
        try {
            const elms = decoder.decode(buffer);
            elms.forEach((elm) => { reader.read(elm); });
            reader.stop();

            let refinedMetadataBuf = tools.makeMetadataSeekable(
                reader.metadatas, reader.duration, reader.cues);
            let body = buffer.slice(reader.metadataSize);
            return new Blob([refinedMetadataBuf, body], {type: blob.type});
        } catch (error) {
            logger.warn('Failed to inject seekable metadata, using raw recording blob.', {
                operation: 'recorder',
                error: error && error.message ? error.message : String(error)
            });
            return blob;
        }
    }).catch((error) => {
        logger.warn('Failed to read recording blob for metadata injection, using raw blob.', {
            operation: 'recorder',
            error: error && error.message ? error.message : String(error)
        });
        return blob;
    });
}

export { injectMetadata }
